import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

import { FormatDate } from '../../helpers';
import { DEFAULT_FORMAT, FULL_DATE_FORMAT } from '../../helpers/format-date.helper';

@Pipe({
    standalone: false,
    name: 'readableDate',
    pure: true
})
export class ReadableDatePipe implements PipeTransform {
    constructor(private readonly datePipe: DatePipe) {}

    transform(value: Date | string | undefined | null, full: boolean = false): string {
        const format = full ? FULL_DATE_FORMAT : DEFAULT_FORMAT;

        if (typeof value === 'string' && value.includes(',')) {
            const transformedValues = value
                .split(',')
                .map(val => val.trim())
                .map(val => FormatDate(this.datePipe, val, format));

            const uniqueValues = [...new Set(transformedValues)];
            return uniqueValues.join(', ');
        }

        return FormatDate(this.datePipe, value, format);
    }
}
